import React, {
  Component,
  useCallback,
  useMemo,
  useRef,
  useState,
} from "react";
import { Sankey, Tooltip } from "recharts";
import _, { filter, flatten } from "lodash";
import DemoSankeyLink from "./DemoSankeyLink";
import DemoSankeyNode from "./DemoSankeyNode";
import { getFlowOfFunds } from "../../../../docuclipper/api";
import { useDispatch, useSelector } from "react-redux";
import { ReduxState } from "../../../../redux";
import AgTable from "../AnalyzeTransactionsTable/AgTable";
import { datefilterParamsYYYYMMDD } from "../AnalyzeTransactionsTable";
import { useTransactions } from "../AnalyzeTransactionsTable/hooks";
import { Button, Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AgGridReact } from "ag-grid-react";
import { fetchMatchedTransactions } from "../../../../redux/reducers/MatchedTransactions";
import SupersetDash from "../Categorize/SupersetPieChart";
import { useIsAdmin } from "src/utils/auth";

// const data = {
//   nodes: [{ name: "Start" }, { name: "Account1" }, { name: "End" }],
//   links: [
//     { source: 0, target: 1, value: 1000 },
//     { source: 0, target: 1, value: 2000 },
//     { source: 1, target: 2, value: 100 },
//     { source: 1, target: 2, value: 1000 },
//   ],
// };

let source;
let destination;
export function FlowOfFunds() {
  const { isAdmin } = useIsAdmin()

  const ref = useRef();

  const externalFilterChanged = useCallback((s, d) => {
    source = s;
    destination = d;
    (ref as any).current.api.onFilterChanged();
  }, []);

  const transactions = useTransactions();

  const [rowData, setRowData] = useState([]);

  const { matches } = useSelector(
    (state: ReduxState) => state.MatchedTransactions
  );

  const dispatch = useDispatch();
  React.useEffect(() => {
    if (matches.length === 0) {
      dispatch(fetchMatchedTransactions());
    }
  }, []);

  const matchedIds = flatten(matches.map((x) => x.transactions)).map(
    (x) => x.id
  );

  React.useEffect(() => {
    setRowData(transactions as any);
  }, [transactions.length]);

  const defaultColDef = useMemo(() => {
    return {
      resizable: true,
    };
  }, []);

  const [columnDefs] = useState([
    {
      field: "account",
    },
    {
      field: "date",
      filter: "agDateColumnFilter",
      filterParams: datefilterParamsYYYYMMDD,
      sortable: true,
    },
    {
      field: "name",
      filter: "agTextColumnFilter",
      filterParams: {
        // pass in additional parameters to the Text Filter
      },
    },
    {
      field: "amount",
      filter: "agNumberColumnFilter",
      sortable: true,
      filterParams: {
        // pass in additional parameters to the Number Filter
      },
    },
    { field: "category", filter: "agSetColumnFilter" },
  ]);
  const onBtnExport = useCallback(() => {
    if (ref && ref.current) {
      (ref.current as any).api.exportDataAsCsv();
    }
  }, []);
  const { job } = useSelector((state: ReduxState) => state.JobData);
  const [data2, setData2] = React.useState({ nodes: [], links: [] });
  React.useEffect(() => {
    if (job) {
      getFlowOfFunds(job.id)
        .then((data) => {
          setData2(data);
        })
        .catch((err) => null);
    }
  }, []);
  // const [source, setSource] = React.useState();
  // const [destination, setDestination] = React.useState();
  if ((data2.links || []).length === 0) {
    return null;
  }
  if ((data2.nodes || []).length === 0) {
    return null;
  }
  // if (data.nodes.length === 0) {
  //   return null;
  // }
  function handleLinkClick(link, event) {
    // console.log("Link clicked!", link);
  }
  function handleNodeClick(node, event) {
    // console.log("Node clicked!", node);
    if (node.payload.name) {
      // account node
    } else if (node.payload.source && node.payload.target) {
      // link node
      // console.log(`${node.payload.source.name} to ${node.payload.target.name}`);
      // setSource(node.payload.source.name);
      // setDestination(node.payload.target.name);
      externalFilterChanged(node.payload.source.name, node.payload.target.name);
    }
  }

  function filterFn(rowNode) {
    if (!source || !destination) {
      return true;
    }
    if (source === "Income") {
      if (matchedIds.includes(rowNode.data.id)) {
        return false;
      }
      return (
        rowNode.data.account === destination &&
        parseFloat(rowNode.data.amount) >= 0
      );
    } else if (destination === "Expenses") {
      if (matchedIds.includes(rowNode.data.id)) {
        return false;
      }
      return (
        rowNode.data.account === source && parseFloat(rowNode.data.amount) <= 0
      );
    } else {
      // source and destination are accounts
      // is a match and account names match
      if (!matchedIds.includes(rowNode.data.id)) {
        return false;
      }
      // make sure it's between source and destination
      const sourceMatch = matches.filter(
        (x) => x.match.sourceTransactionId === rowNode.data.id
      );
      const destinationMatch = matches.filter(
        (x) => x.match.destinationTransactionId === rowNode.data.id
      );
      if (sourceMatch.length > 0) {
        const t = sourceMatch[0].transactions[0]; // 1st one
        return t.account === source;
      } else if (destinationMatch.length > 0) {
        const t = destinationMatch[0].transactions[1]; // 2nd one
        return t.account === destination;
      }

      return false;
    }
  }
  return (
    <div className="sankey-charts">
      {/* <div>
        <pre>1. Simple Sankey</pre>
        <Sankey width={960} height={500} data={data1}>
          <Tooltip />
        </Sankey>
      </div>
      <br />
      <div>
        <pre>2. Customized Sankey.</pre>
        <Sankey
          width={960}
          height={500}
          data={data0}
          node={{ fill: "#8a52b6" }}
          link={{ stroke: "#77c878" }}
        ></Sankey>
      </div>
      <br /> */}
      <div>
        <Sankey
          width={960}
          height={500}
          margin={{ top: 20, bottom: 20, left: 20, right: 60 }}
          data={data2}
          nodeWidth={10}
          nodePadding={60}
          linkCurvature={0.61}
          iterations={64}
          link={<DemoSankeyLink />}
          node={<DemoSankeyNode containerWidth={960} />}
          // handleClick={() => null}
          // onLinkClick={handleLinkClick}
          onClick={handleNodeClick}
        >
          <defs>
            <linearGradient id={"linkGradient"}>
              <stop offset="0%" stopColor="rgba(0, 136, 254, 0.5)" />
              <stop offset="100%" stopColor="rgba(0, 197, 159, 0.3)" />
            </linearGradient>
          </defs>
          <Tooltip />
        </Sankey>
      </div>

      <div className="h3 mt-4">Transactions</div>

      <Row>
        <Col>
          <Button variant="link" onClick={onBtnExport}>
            <FontAwesomeIcon icon="download" />
            <span className="ml-1">Export as CSV</span>
          </Button>
        </Col>
        <Col>
          <Button
            variant="link"
            onClick={() => {
              externalFilterChanged(undefined, undefined);
            }}
          >
            <FontAwesomeIcon icon="trash" />
            <span className="ml-1">Clear Filters</span>
          </Button>
        </Col>
      </Row>

      <Row>
        <div className="ag-theme-alpine" style={{ height: 600, width: "100%" }}>
          <AgGridReact
            singleClickEdit
            defaultColDef={defaultColDef}
            ref={ref as any}
            rowData={rowData}
            columnDefs={columnDefs}
            isExternalFilterPresent={() => true}
            doesExternalFilterPass={filterFn}
          ></AgGridReact>
        </div>
      </Row>
      {isAdmin && (
        <Row>
          <SupersetDash
            dashboardName={"flowOfFunds"}
            height={'600px'}
            width={'100%'}
            reload={true} // change dinamically to reload the dashboard
          />
        </Row>
      )}
    </div>
  );
}

export default FlowOfFunds;
